import React from "react"
import PropTypes from "prop-types"
import {
  rendezVousTitle,
  rendezVousSubContainer,
} from "../Part1/rendez-vous-part-1.module.scss"
import {
  RendezVousSubContainer,
  RendezVousTitle,
} from "../rendez-vous-styled.js"

export const RendezVousPart2 = ({ typesRendezVousData, typeChoisi }) => {
  return (
    <RendezVousSubContainer className={rendezVousSubContainer}>
      <RendezVousTitle className={rendezVousTitle}>
        Information pour votre rendez-vous
      </RendezVousTitle>
      {typesRendezVousData[typeChoisi] && (
        <>
          <div
            dangerouslySetInnerHTML={{
              __html:
                typesRendezVousData[typeChoisi].texte_commentaire[0].processed,
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: typesRendezVousData[typeChoisi].texte_rgpd[0].processed,
            }}
          />
        </>
      )}
    </RendezVousSubContainer>
  )
}

RendezVousPart2.propTypes = {
  typesRendezVousData: PropTypes.object,
  typeChoisi: PropTypes.string,
}
